import api from '@/api'

export function fetchObservations () {
  return api.get('/enums/')
}
